function updateSavedButtons(posts) {
  const buttons = Array.from(document.querySelectorAll('[data-button="save-post"]'))

  // Convert object of post ID into an array
  const savedPostIds = Object.values(posts)

  // Remove the active state for all buttons
  buttons.forEach(button => {
    const svgEl = button.querySelector('svg')
    const theme = button.dataset.theme
    
    if (theme === 'dark') {
      svgEl.classList.remove('text-white') 
      svgEl.classList.add('text-black') 
    } else {
      svgEl.classList.remove('text-black')
      svgEl.classList.add('text-white')
    }
  })

  // Add the active state for items in the saved post list
  savedPostIds.forEach(id => {
    const matchingButton = document.querySelector(`[data-button="save-post"][data-id="${id}"]`)

    if (matchingButton) {
      const svgEl = matchingButton.querySelector('svg')
      const theme = matchingButton.dataset.theme

      if (theme === 'dark') {
         svgEl.classList.add('text-white') 
         svgEl.classList.remove('text-black') 
      } else {
        svgEl.classList.add('text-black')
        svgEl.classList.remove('text-white')
      }
    }
  })
}


// When the page loads, fetch the users saved posts
// Then run the updateSavedButtons function to make those highlighted
function highlightActiveOnLoad() {
  $.ajax({
    // eslint-disable-next-line no-undef
    url: ajaxObject.ajaxURL,
    type: 'post',
    dataType: 'json',
    async: false,
    data: {
      action: 'ajax_get_save_posts',
    },
    success: (posts) => {
      updateSavedButtons(posts)
    },
  })
}

if (document.body.classList.contains('logged-in')) {
  highlightActiveOnLoad()
}


function savePost() {
  const buttons = Array.from(document.querySelectorAll('[data-button="save-post"]'))
  
  if (buttons) {

    // Setup the AJAX calls to add/remove items from the user's saved items.
    // These are saived to their user profile
    buttons.forEach(button => {

      button.addEventListener('click', event => {
        event.preventDefault()
      
        $.ajax({
          // eslint-disable-next-line no-undef
          url: ajaxObject.ajaxURL,
          type: 'post',
          dataType: 'json',
          async: false,
          data: {
            action: 'ajax_save_post',
            id: button.dataset.id,
          },
          success: (posts) => {
            updateSavedButtons(posts)
            console.log('🚀 ~ file: save-post.js ~ line 81 ~ savePost ~ posts', posts)
          },
        })
      })
      
    })
  }
}

savePost()


// WEBPACK FOOTER //
// ./scripts/components/save-post.js